<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-input ttLabel="prod_id_and_name" [ttModel]="setting.prod_id_and_name" ttReadonly></tt-input>
    </tt-card>

    <tt-grid *ngIf="!!gridPo" class="col-xs-12 p-5" [(ttOptions)]="gridPo"></tt-grid>
    <tt-grid *ngIf="!!gridPoWorkSum" class="col-xs-12 p-5" [(ttOptions)]="gridPoWorkSum"></tt-grid>
</tt-page>
